import React, { useState } from "react";
import { useSelector } from "react-redux";
import { PrintersItemContainer } from "./PrintersItemContainer";
import { useProductsData } from "../menu/products/useProductsData";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { IReduxAppState } from "../../reducers";
import { useSideTabs } from "../../hooks/useSideTabs";
import { DisableRouteComponent } from '../util/DisableRouteComponent';
import { IListItem } from "./types"
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { MultiDialogRoute } from "../dialogRoutes/MultiDialogRoute";
import { PrintersDialog } from "./PrinterDialog";
import { ADD_ITEM, BY_ID, dialogKeys } from "../../const/URL.const";
import { useStyles } from "./ui/styles";
import { AddExtrasFormDialog } from "../menu/products/extras/ui/AddExtrasFormDialog";

export function PrintersSettingsContainer(props: any) {
    const [printersList, setPrintersList] = useState<IListItem[]>([]);
    const position = useSideTabs(props.tab);
    const venueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const { callAPI, isLoading } = useProductsData(APIExtensions.printers, venueId, setPrintersList, {});
    let { path } = useRouteMatch();

    const style = useStyles()

    return <Switch>
        <DisableRouteComponent pageKey={position}>
            <Route path={path}>
                <PrintersItemContainer
                    isLoading={isLoading}
                    printersList={printersList}
                    venueId={venueId}
                    path={path}
                />
                <MultiDialogRoute
                    RouteSteps={[
                        {
                            key: dialogKeys.PRINTER,
                            Component: PrintersDialog,
                            path: `${path}${BY_ID}`,
                            exact: true,
                            dialogClassName: style.modalContainer,
                            title: "Printers",
                            isFormDialog:true,
                            componentProps: {
                                hasFrame: false,
                                path: path,
                                printerCallApi: callAPI
                            },
                        },
                        {
                            key: dialogKeys.ASSIGNITEM,
                            Component: AddExtrasFormDialog,
                            path: `${path}${BY_ID}${ADD_ITEM}`,
                            dialogClassName: style.modalContainer,
                            title: "orderHistory.modal.title",
                            isFormDialog:true,
                            componentProps: {
                                hasFrame: false,
                                noSortApi: true,
                            },
                        },
                    ]}
                    navigateBackRotue={path}
                />
            </Route>
        </DisableRouteComponent>
    </Switch>
}